var CommonBaseView, HoldTimeDisplayTemplate, HoldTimeView, SharedSpinnerView, SupportUtils,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

HoldTimeDisplayTemplate = require('../../../../hold_time_display.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

SharedSpinnerView = require("../../../../../shared/frontend/views/spinner_view");

SupportUtils = require("../../../helpers/utils");

HoldTimeView = (function(superClass) {
  extend(HoldTimeView, superClass);

  function HoldTimeView() {
    this.displayHoldTime = bind(this.displayHoldTime, this);
    return HoldTimeView.__super__.constructor.apply(this, arguments);
  }

  HoldTimeView.prototype.initialize = function(params) {
    this.template = HoldTimeDisplayTemplate;
    this.spinnerView = new SharedSpinnerView();
    return this.model = params.model;
  };

  HoldTimeView.prototype.render = function() {
    this.model.getWaitTimeInformation(I18n.locale, this.displayHoldTime);
    return this.showLoadingSpinner('#call-back-spinner', '40px');
  };

  HoldTimeView.prototype.toHash = function(waitTime) {
    return {
      holdTime: waitTime
    };
  };

  HoldTimeView.prototype.displayHoldTime = function(waitTime) {
    this.hideLoadingSpinner('#call-back-spinner');
    this.$el.empty();
    this.$el.append(toHtml(this.template, this.toHash(waitTime), this.I18nScope));
    return $('#call-back-hold-time').append(this.$el);
  };

  HoldTimeView.prototype.updateHoldTime = function(locale) {
    $("#call-back-hold-time").empty();
    this.showLoadingSpinner('#call-back-spinner', '40px');
    return this.model.getWaitTimeInformation(locale, this.displayHoldTime);
  };

  HoldTimeView.prototype.hideLoadingSpinner = function(element) {
    $(element).empty();
    return window.hideDOMElems($(element));
  };

  HoldTimeView.prototype.showLoadingSpinner = function(element, size) {
    window.showDOMElems($(element));
    return SupportUtils.showLoading($(element), size);
  };

  return HoldTimeView;

})(CommonBaseView);

module.exports = HoldTimeView;

//# sourceMappingURL=data:application/json;base64,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
